import store from "@/store";
import axios from "axios";

import { processAxiosNetworkError } from "@/notify";
import { MAX_PAGE_SIZE } from "@/constants";

export class ListLoader {
  constructor(url, { defaultParams = {}, setter = null, isSingleRequest = true } = {}) {
    this.promise = null;
    this.url = url;
    this.params = { page_size: MAX_PAGE_SIZE, ...defaultParams };
    this.setter = setter;
    this.isSingleRequest = isSingleRequest;
  }

  updateStore(data) {
    if (this.setter) {
      store.commit(this.setter, data.results || data);
    }
  }

  fetch(extraParams = {}) {
    if (this.promise && this.isSingleRequest) {
      return this.promise;
    }
    this.promise = axios
      .get(this.url, { params: { ...this.params, ...extraParams } })
      .then((response) => {
        this.updateStore(response.data);
        return response;
      }, processAxiosNetworkError);
    return this.promise;
  }

  bulkUpdate(data, params) {
    return axios.post(`${this.url}bulk_update/`, data, { params }).then((response) => {
      this.updateStore(response.data);
      return response;
    });
  }
}

export class ItemLoader {
  constructor(baseUrl, { setter = null, remover = null, lookupField = "id" } = {}) {
    this.baseUrl = baseUrl;
    this.setter = setter;
    this.remover = remover;
    this.lookupField = lookupField;
  }

  getId(data) {
    return data[this.lookupField];
  }

  updateStore(data) {
    if (this.setter) {
      store.commit(this.setter, data);
    }
  }

  create(data, params) {
    return axios.post(this.baseUrl, data, { params }).then((response) => {
      this.updateStore(response.data);
      return response;
    });
  }

  update(data, params) {
    return axios
      .put(`${this.baseUrl}${this.getId(data)}/`, data, { params })
      .then((response) => {
        this.updateStore(response.data);
        return response;
      });
  }

  save(data, params) {
    if (this.getId(data)) {
      return this.update(data, params);
    }
    return this.create(data, params);
  }

  retrieve(id) {
    return axios.get(`${this.baseUrl}${id}/`).then((response) => {
      this.updateStore(response.data);
      return response;
    }, processAxiosNetworkError);
  }

  get() {
    return axios.get(this.baseUrl).then((response) => {
      this.updateStore(response.data);
      return response;
    }, processAxiosNetworkError);
  }

  delete(id) {
    return axios.delete(`${this.baseUrl}${id}/`).then((response) => {
      if (this.remover) {
        store.commit(this.remover, id);
      }
      return response;
    });
  }
}
